export const enableContinueBtn = (companyStockFlag, rolloverToRothIRAFlag) =>
  companyStockFlag !== '' && rolloverToRothIRAFlag !== '';
